<template>
  <div id="delivery-form-list" class="list">
    <div class="delivery-form-list-header list-header">
      <ul>
        <li>{{$_('model_reference')}}</li>
        <li>{{$_('designation')}}</li>
        <li>{{$_('size')}}</li>
        <li>{{$_('color')}}</li>
        <li>{{$_('packaging')}}</li>
        <li>{{$_('delivered_quantity')}}</li>
        <li>{{$_('satab_number_order')}}</li>
        <li>{{$_('customer_order_reference')}}</li>
        <li>{{$_('customer_product_reference')}}</li>
      </ul>
    </div>
    <div class="delivery-form-list-body list-body">
      <div v-for="(item, index) in items" :key="index">
        <DeliveryFormDetailsLine :dataline="item" :index="index" />
      </div>
    </div>
  </div>
</template>

<script>
import deliveryService from '@/modules/facture/services/deliveryService.js';

import DeliveryFormDetailsLine from '@/modules/facture/components/DeliveryFormDetailsLine';

export default {
  name: 'DeliveryFormDetailsList',
  data() {
    return {
      items: Array(),
    };
  },
  created() {
    this.vLoadDeliveryFormDetails();
  },
  computed: {
    getResearch() {
      return this.$store.getters['facture/get_launch_delivery_details_research']
    },
  },
  watch: {
    getResearch(val) {
      if(val === true) {
        this.vLoadDeliveryFormDetails();
      }
    }
  },
  methods: {

    vLoadDeliveryFormDetails() {

      return deliveryService.getDeliveryFormDetails({
        fmod: this.$store.getters['facture/get_delivery_details_tmod'] !== '' ?  this.$store.getters['facture/get_delivery_details_tmod'] : null,
        fcol: this.$store.getters['facture/get_delivery_details_tcol'] !== '' ? this.$store.getters['facture/get_delivery_details_tcol'] : null,
        ftail: this.$store.getters['facture/get_delivery_details_ttaille'] !== '' ? this.$store.getters['facture/get_delivery_details_ttaille'] : null,
        frefc: this.$store.getters['facture/get_delivery_details_trefc'] !== '' ? this.$store.getters['facture/get_delivery_details_trefc'] : null,
        pnbl: this.$route.params.delivery_form_id
    
      }).then(res => {

        this.items = Array();
      
        if( res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map((obj) => {
            this.items.push(obj)
          })
        }

        this.$store.dispatch('facture/SELECT', {key: 'launch_delivery_details_research', value: false});

      }).catch(err => {
        console.error(err)
      });
    }
  },
  components: {
    DeliveryFormDetailsLine,
  },
}
</script>

<style scoped>
.delivery-form-list-header ul {
  display: flex;
  align-items: center;
}
.delivery-form-list-header ul li {
  list-style-type: none;
  display: flex;
  width: calc(100% / 9);
  text-align: center;
  padding: 0px 20px;
  justify-content: center;
}
.delivery-form-list-header {
  padding: 15px 0px;
}
.no-result {
  text-align: center;
  padding: 20px;
  border: solid 1px purple;
  margin-bottom: 20px;
}
</style>